import React, { useEffect, useState, useRef } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Button from "shared/Button";
import { colors } from "styles/colors";
import { Wrapper, BtnWrap, Title, Preview, OriginalImgWrap } from "./styled";

const ImageEditor = ({ image, setSave, closeModal }) => {
  const [loading, setLoading] = useState(false);
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [crop, setCrop] = useState({
    unit: "px",
    width: 240,
    height: 242,
    aspect: 8 / 8,
  });
  const [completedCrop, setCompletedCrop] = useState(null);

  useEffect(() => {
    if (!imgRef.current) {
      return;
    }
    const img = imgRef.current;
    if (img.width < 240 || img.height < 242) {
      setCrop({ ...crop, width: img.width, height: img.height });
    }
  }, [imgRef.current]);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }
    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  }, [image, completedCrop]);

  const onClickSave = (e) => {
    e.preventDefault();
    if (previewCanvasRef) {
      const croppedImg = previewCanvasRef.current.toDataURL();
      setLoading(true);
      closeModal();
      setSave(croppedImg);
      setLoading(false);
    }
  };

  const onLoad = (img) => {
    imgRef.current = img;
  };

  return (
    <>
      <Wrapper>
        <OriginalImgWrap width={imgRef.current && imgRef.current.width < 500 ? imgRef.current.width : 500}>
          <Title>Original image</Title>
          <ReactCrop
            src={image}
            onImageLoaded={onLoad}
            crossorigin="s3:PutBucketCORS"
            crop={crop}
            onChange={(c) => setCrop(c)}
            onComplete={(c) => setCompletedCrop(c)}
          />
        </OriginalImgWrap>
        <Preview>
          <Title>Preview</Title>
          <canvas
            ref={previewCanvasRef}
            style={{
              width: "240px",
              height: "242px",
              borderRadius: "10px",
            }}
          />
        </Preview>
      </Wrapper>
      <BtnWrap>
        <Button stylType="primary" color={colors.RED} text="Confirm" disabled={loading} onClick={onClickSave} />
      </BtnWrap>
    </>
  );
};

export default ImageEditor;
